import { render, staticRenderFns } from "./signatureProxy.vue?vue&type=template&id=157793c4"
import script from "./signatureProxy.vue?vue&type=script&lang=js"
export * from "./signatureProxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157793c4')) {
      api.createRecord('157793c4', component.options)
    } else {
      api.reload('157793c4', component.options)
    }
    module.hot.accept("./signatureProxy.vue?vue&type=template&id=157793c4", function () {
      api.rerender('157793c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/signatureProxy.vue"
export default component.exports